import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import useSession from './useSession';

/**
 * Wrapper component that gates access behind Frappe authentication.
 *
 * - While checking session: shows a loading spinner.
 * - If not authenticated: navigates to /auth-login (React route, no full reload).
 * - If authenticated: renders children.
 */
export default function AuthGate({ children }) {
  const { user, isLoading, isError } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={48} />
        <Typography color="text.secondary">Checking session...</Typography>
      </Box>
    );
  }

  if (isError || !user) {
    // Navigate to our React login page, preserving the intended destination
    return <Navigate to="/auth-login" state={{ from: location }} replace />;
  }

  return children;
}
